module.exports = __webpack_public_path__ + "img/Child-Friendly.782fc446.svg";